export default function isE2ETestOffer(offerName) {
  const usingTestApi = window.configs.API_HOST === 'https://test-api.luxuryescapes.com';
  const isE2EOffer = offerName?.includes('E2E');
  return usingTestApi && isE2EOffer;
}
